export function user(state = '', action) {
  switch (action.type) {
    case 'SET_USER':
      return action.userLogged
    default:
      return state
  }
}